import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'lib/store';

type AudioSettings = {
  isMuted: boolean;
  showClosedCaptions: boolean;
  volume: number;
};

export const initialState: AudioSettings = {
  isMuted: false,
  showClosedCaptions: false,
  volume: 0.5,
};

const mediaSlice = createSlice({
  initialState,
  name: 'media',
  reducers: {
    setVolume: (state, action: PayloadAction<AudioSettings['volume']>) => {
      return {
        ...state,
        volume: action.payload,
      };
    },
    toggleClosedCaptions: (state) => {
      return {
        ...state,
        showClosedCaptions: !state.showClosedCaptions,
      };
    },
    toggleMuteAudio: (state) => {
      return {
        ...state,
        isMuted: !state.isMuted,
      };
    },
  },
});

const { actions, reducer } = mediaSlice;

export const { setVolume, toggleClosedCaptions, toggleMuteAudio } = actions;

export const selectVolume = (state: RootState) => state.media.volume;

export const selectIsMuted = (state: RootState) => state.media.isMuted;

export const selectShowClosedCaptions = (state: RootState) =>
  state.media.showClosedCaptions;

export default reducer;
